import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";
import { useAdminTheme } from "./AdminLayout";
import { FilterBar, useAdminFilters, cityParam } from "./filters";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function AdminCouriers() {
  const { accent } = useAdminTheme();
  const f = useAdminFilters();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/admin/couriers", { params: { city_id: cityParam(f) } }).then(({ data }) => setRows(data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [f.cityId]);

  return (
    <div data-testid="admin-couriers">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-display text-3xl font-extrabold">Gestão de motoboys</h1>
          <p className="text-sm text-gray-500">{rows.length} entregadores cadastrados</p>
        </div>
        <FilterBar f={f} accent={accent} />
      </div>

      <div className="rounded-2xl border border-gray-200 bg-white mt-6 overflow-x-auto">
        <Table data-testid="couriers-table">
          <TableHeader>
            <TableRow>
              <TableHead>Entregador</TableHead>
              <TableHead>Contato</TableHead>
              <TableHead>Veículo</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Avaliação</TableHead>
              <TableHead className="text-right">Corridas</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((c) => (
              <TableRow key={c.id} data-testid={`courier-row-${c.email}`}>
                <TableCell className="font-semibold">{c.name}</TableCell>
                <TableCell className="text-gray-600 text-xs">{c.email}<br />{c.phone}</TableCell>
                <TableCell className="text-gray-600 text-xs">
                  {c.vehicle ? `${c.vehicle.tipo} · ${c.vehicle.modelo} · ${c.vehicle.placa}` : "—"}
                </TableCell>
                <TableCell>
                  <span
                    className="text-[10px] font-bold px-2 py-1 rounded-full text-white"
                    style={{ background: c.online ? "#2E8B57" : "#9CA3AF" }}
                  >
                    {c.online ? "ONLINE" : "OFFLINE"}
                  </span>
                </TableCell>
                <TableCell>
                  <span className="flex items-center gap-1 text-sm font-bold">
                    <Star size={12} fill="#F5C518" stroke="none" /> {(c.rating || 5).toFixed(1).replace(".", ",")}
                  </span>
                </TableCell>
                <TableCell className="text-right font-display font-extrabold">{c.rides}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
